import { render, staticRenderFns } from "./print-foot.vue?vue&type=template&id=4d5f3f79&scoped=true"
import script from "./print-foot.vue?vue&type=script&lang=js"
export * from "./print-foot.vue?vue&type=script&lang=js"
import style0 from "./print-foot.vue?vue&type=style&index=0&id=4d5f3f79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f3f79",
  null
  
)

export default component.exports